import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation, Link ,useNavigate} from 'react-router-dom';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import Header from '../../components/header';
import Sidebar from '../../components/sidebar';
import Footer from '../../components/footer';
import Logo from '../../images/logo.png'
import { QRCodeCanvas } from 'qrcode.react';
import Loader from '../../components/loader';

function convertNumberToWords (number) {
    const units = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
    ];
    const tens = [
      "",
      "Ten",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];
    const teens = [
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const crore = "Crore";
    const lakh = "Lakh";
    const arab = "Arab";
    const currency = "Rupees";
    const paisa = "Paisa";
    
    if (number === 0) {
      return "Zero " + currency;
    }

    let words = "";
    
    if (number >= 1000000000) {
      words +=
        convertNumberToWords(Math.floor(number / 1000000000)) +
        " " +
        arab +
        " ";
      number %= 1000000000;
    }
    if (number >= 10000000) {
      words +=
        convertNumberToWords(Math.floor(number / 10000000)) + " " + crore + " ";
      number %= 10000000;
    }

    if (number >= 100000) {
      words +=
        convertNumberToWords(Math.floor(number / 100000)) + " " + lakh + " ";
      number %= 100000;
    }

    if (number >= 1000) {
      words += convertNumberToWords(Math.floor(number / 1000)) + " Thousand ";
      number %= 1000;
    }

    if (number >= 100) {
      words += convertNumberToWords(Math.floor(number / 100)) + " Hundred ";
      number %= 100;
    }

    if (number >= 20) {
      words += tens[Math.floor(number / 10)] + " ";
      number %= 10;
    } else if (number >= 10) {
      //console.log(number);
      words += teens[number - 10] + " ";
      number = 0;
      //console.log(words);
    }

    if (number > 0) {
      words += units[number] + " ";
    }
    const decimalPart = Math.round((number % 1) * 100);
    //console.log(decimalPart);
    if (decimalPart > 0) {
      words += "and" + decimalPart + " " + paisa + "only ";
    }
    
    //console.log(words);
    return words.trim() + " ";
  };

const InvoicePage = () => {

    const userID = sessionStorage.getItem("TRCUserId");
	const userEmail = sessionStorage.getItem("TRCUserEmail");
	const userName = sessionStorage.getItem("TRCUserName");
	const userPosition = sessionStorage.getItem("TRCUserPosition");
    const userType = sessionStorage.getItem("TRCUserType");

    const location = useLocation();
    const getQueryParam = (param) => {
        const urlParams = new URLSearchParams(location.search);
        return urlParams.get(param);
    };
    
    const orderId = getQueryParam('id');
    const [loader, setLoader] = useState(false);
    const [getData, setGetData] = useState('');
    const [total, setTotal] = useState(0);
    const [grandTotal, setGrandTotal] = useState(0);
    const [gst, setGST] = useState(0);
    const [gst2, setGST2] = useState(0);
    const [crates, setCrates] = useState(0);
    const [qty, setQty] = useState(0);
    const [scheme, setScheme] = useState(0);
    const [totalLtr, setTotalLtr] = useState(0);

    const [newDiscountData, setNewDiscountData] = useState([]);
    const [newTotal, setNewTotal] = useState(0);
    const [newGst, setNewGst] = useState(0);
    const [newDiscount, setNewDiscount] = useState(0);

    const [discSec, setDiscSec] = useState(false);

    let cratesTotal = 0;
	let qtyTotal = 0;
	let weightTotal = 0;
	let orderTotal = 0;
    let gstTotal = 0;
    let disCratesTotal = 0;

    const getdata = async () => {
		try {
			const response = await axios.post('https://api.trucoo.in/orders/order-details/',{orderId: orderId}, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});
		
            //console.log(response.data);

			if(response.data.status === 'success'){
				setGetData(response.data.data);
			}
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}
	};

    const getSchemeDate = () => {
        const today = new Date();
        const startDate = new Date(getData?.dealerData?.dateFrom);
        const endDate = new Date(getData?.dealerData?.dateTo);
        startDate.setHours(0, 0, 0, 0);
        endDate.setHours(23, 59, 59, 999);
        today.setHours(0, 0, 0, 0);
        const isDateInRange = today >= startDate && today <= endDate;
        return isDateInRange;
    };

    const companyData = {
        companyName: "TRUCOO DAIRY PRODUCTS PRIVATE LIMITED",
        companyAddress1: "C201, SK Hill view Apartment",
        companyAddress2: "Rainbow Enclave",
        companyLocation: "Sugunapuram Mylkal",
        companyCity: "Coimbatore",
        companyState: "Tamil Nadu",
        companyZip: "641008",
        companyPhone: "+91 81900 03400",
        companyEmail: "cbeoffice@trucoo.in",
        companyGst: "GSTIN: 33AKCT9681P1ZC",
        ts: "Sample Terms and Conditions"
    };   

    const getTotal = () => {
        // Initialize totals to zero
        let allTotal = 0;
        let allGst = 0;
        let allQty = 0;
        let allSubTotal = 0;
        let totalLtr = 0;
        let scheme = 0;
        let allCrates = 0;
    
        getData?.orderData?.forEach(data => {

            const price = parseFloat(data.price).toFixed(2) || 0;
            const gst = parseFloat(data.gst) || 0;
            const disCrates = getDiscountCrates(data.id);
            
            const productGst = price - (price / (1 + gst / 100)) || 0;
            const productPrice = parseFloat(price - productGst).toFixed(2) || 0;
    
            allTotal += price * ((parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.crates));
            allGst += productGst * ((parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.crates));
            allSubTotal += productPrice * (parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.crates);
            allCrates += (parseFloat(data.qty) + parseFloat(disCrates) ) || 0;
            allQty+= (parseFloat(data.qty) + parseFloat(disCrates) ) *  parseFloat(data.crates)|| 0;
            totalLtr += (((parseFloat(data.qty) + parseFloat(disCrates))* parseFloat(data.crates)) * parseFloat(data.weight)/1000);

            const schemeCheck = getSchemeDate();
            //console.log(schemeCheck);

            if(schemeCheck){
                const value = getData?.dealerData?.values;
                const fraction = getData?.dealerData?.fraction;
                if ( parseFloat(value) > 0 && parseFloat(fraction) > 0 ){
                    const ltr = ((parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.crates) * parseFloat(data.weight)/1000);
                    const schemeValue = (ltr / parseFloat(value)) * parseFloat(fraction);
                    //console.log(ltr);
                    scheme += price * schemeValue;
                }
            }
        });
    
        // Set the final values
        setTotal(allSubTotal);
        setGST(allGst);
        setGST2(parseFloat(allGst/2).toFixed(2));
        setQty(allQty);
        setCrates(allCrates);
        setGrandTotal(allTotal);
        setTotalLtr(totalLtr);
        setScheme(scheme);
    };
    
    const payable = (parseFloat( parseFloat(total) + parseFloat(gst2) + parseFloat(gst2) ) - parseFloat(newDiscount) - parseFloat(scheme)).toFixed(2);


    const totalAmountInWords = convertNumberToWords( parseFloat(Math.round(payable)).toFixed(0));

    const getDiscountCrates = (product) => {
     
        const productData = getData?.orderData?.find(items => items.item === product);
        const discountData = newDiscountData?.find(items => items.item === product); 
    
        if (!productData || !discountData) {
            console.warn("Product or discount not found in getDiscountCrates");
            return 0; 
        } 
    
        const qty = parseFloat(productData.qty);
        const price = parseFloat(productData.price);
        const crates = parseFloat(productData.crates);
        const weight = parseFloat(productData.weight);
        const gst = parseFloat(productData.gst);
        const productGst = price - (price / (1 + gst / 100)) || 0;
        const productPrice = price - productGst || 0;
    
        if (isNaN(qty) || isNaN(productPrice) || isNaN(crates) || isNaN(weight)) {
            console.warn("Invalid product data");
            return 0;
        }
    
        if (!discountData.value || isNaN(discountData.value)) {
            console.warn("Invalid discount value");
            return 0;
        }

        if(discountData.discount === 'amount'){
            return 0;
        }
    
        if (discountData.type === 'grade') {
            if (discountData.discount === 'packet') {
                return (parseFloat(discountData.value) * qty) / crates;
            } else {
                return ((parseFloat(discountData.value) * qty) / productPrice) / crates;
            }
        }
    
        if (discountData.type === 'percent') {
            const total = qty * crates * productPrice;
            return total * (parseFloat(discountData.value) / 100);
        }
    
        if (discountData.type === 'liters') {
            if (discountData.discount === 'packet') {
                const ltrs = qty * crates * (weight/1000);
                const discLtr = ltrs * discountData.value;
                return (discLtr / crates);
            } else {
                const ltrs = qty * crates * (weight/1000);
                const ltrprice = ltrs * discountData.value;
                const ltrQty = ltrprice/productPrice;
                return (ltrQty / crates);
            }
        }
        if (discountData.type === 'packet') {
            const values = parseFloat(discountData.value);
            const disQty = qty * crates;
            return (disQty * values) / crates;
        }
    
        return 0;
    };
    
    const saveData = async () => {

        setLoader(true);
        
        const sendDatas = {
            dealerId: getData?.dealerData?.id,
            total: parseFloat(orderTotal) + parseFloat(gstTotal),
            gst: gstTotal,
            discount: (newDiscount+scheme),
            items: getData?.orderData,
            orderId: orderId,
            schemeValue: scheme,
            scheme: `(${getData?.dealerData?.values}/${getData?.dealerData?.fraction})`,
            crates: crates,
            vNum: getData?.vNum || '',
            evNum: getData?.evNum || '',
            discountData: newDiscountData,
            ships: getData?.shipping?.id,
            dispatch: getData?.dispatch,
            user: userID
        };

        try{
            const response = await axios.post('https://api.trucoo.in/invoice/add-invoice/', sendDatas, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});

            //console.log(response.data);

            if(response.data.status === 'success'){
                //downloadPDF();
                getdata();
                getTotal();
            }

        }catch (error) {
			console.error("Error:", error.response || error.message);
		}
        setLoader(false);
    };
    

    const downloadPDF = () => {
        const invoiceElement = document.getElementById("printableArea");
    
        html2canvas(invoiceElement, { scale: 3 }).then((canvas) => {
          const imgData = canvas.toDataURL("image/jpeg");
          const pdf = new jsPDF("p", "mm", "a4");
    
          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
    
          pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);
          pdf.save(`${getData?.id}-PRO_FORMA-${getData?.orderDate}`);
        });

        getdata();
    };

    useEffect(() => {
        getdata();
        getTotal();
    },[]);

 

    useEffect(() => {
        getTotal();
    },[newDiscount, scheme, getData]);

    const note = 'PRO_FORMA';
    const upiId = '73601701@ubin';
    const payeeName = 'TRUCOO DAIRY PRODUCTS PRIVATE LIMITED';
    const payableQR = parseFloat(Math.round(payable).toFixed(2));

    const generateUpiLink = () => {
        const upiLink = `upi://pay?pa=${upiId}&am=${payableQR}&cu=INR&pn=${payeeName}&tn=${note}`;
        return upiLink;
    };

    const getNewDiscounts = (product) => {
        
        const productData = getData?.orderData?.find(items => items.item === product);
        const discountData = newDiscountData?.find(items => items.item === product); 
    
        const qty = parseFloat(productData.qty);
        const price = parseFloat(productData.price);
        const crates = parseFloat(productData.crates);
        const weight = parseFloat(productData.weight);
        const gst = parseFloat(productData.gst);
        const productGst = price - (price / (1 + gst / 100)) || 0;
        const productPrice = price - productGst || 0;
        

        if (!productData || !discountData) {
             //console.warn("Product or discount not found");
            return 0; 
        }

        if(discountData.discount !== 'amount'){
            return 0;
        }

        if(discountData.type === 'grade'){

            if(discountData.discount === 'packet'){
                return (parseFloat(productPrice) * parseFloat(discountData.value)) * parseFloat(qty)
            }else{
                return parseFloat(discountData.value) * parseFloat(qty)
            }
        }

        if(discountData.type === 'percent'){
            const total = parseFloat(qty) * parseFloat(crates)* parseFloat(productPrice);
            return total*(parseFloat(discountData.value)/100)
        }

        if(discountData.type === 'liters'){

            if(discountData.crate === 'litre'){
                const litters = (parseFloat(qty) * parseFloat(crates)) * (parseFloat(weight)/1000)
                const weights = litters * discountData.value;
                const ltr = (weights * 1000);
                return ltr * productPrice
            }else{
                const litters = (parseFloat(qty) * parseFloat(crates)) * (parseFloat(weight)/1000)
                return litters * discountData.value
            }
        }

        if(discountData.type === 'packet'){
            const values = parseFloat(discountData.value);
            const disQty = parseFloat(qty) * parseFloat(crates);
            return disQty * values;
        }

        return 0;
    };


    const handleDiscountTypeChange = (value, itemId) => {
        setNewDiscountData((prevData) => {
            const itemExists = prevData.some(item => item.item === itemId);

            if (itemExists) {
                // Update existing item
                return prevData.map(item =>
                    item.item === itemId ? { ...item, type: value } : item
                );
            } else {
                // Add new item
                return [...prevData, { type: value, discount: '', value: 0, item: itemId }];
            }
        });
    };

    const handleDiscountValueChange = (value, itemId) => {
        setNewDiscountData((prevData) => {
            const itemExists = prevData.some(item => item.item === itemId);

            if (itemExists) {
                // Update existing item
                //console.log('Exist', itemId);
                return prevData.map(item =>
                    item.item === itemId ? { ...item, value: value } : item
                );
            } else {
                // Add new item
                return [...prevData, { type: '', discount: '', value: value, item: itemId }];
            }
        });
    };

    const handleDiscountDiscountChange = (value, itemId) => {
        setNewDiscountData((prevData) => {
            const itemExists = prevData.some(item => item.item === itemId);

            if (itemExists) {
                // Update existing item
                return prevData.map(item =>
                    item.item === itemId ? { ...item, discount: value } : item
                );
            } else {
                // Add new item
                return [...prevData, { type: '', discount: value, value: 0, item: itemId }];
            }
        });
    };

    const getNewTotal = () => {
        let allTotal = 0;
        let allGst = 0;
        let allQty = 0;
        let allSubTotal = 0;
        let newDiscountValue = 0;
    
        getData?.orderData?.forEach((data, index) => {
            
            const price = parseFloat(data.price) || 0;
            const gst = parseFloat(data.gst) || 0;
            const disCrates = getDiscountCrates(data.item);
            const discount = getNewDiscounts(data.item);
            const productGst = price - (price / (1 + gst / 100)) || 0;
            const productPrice = parseFloat(price - productGst).toFixed(2) || 0;
    
            allTotal += price * (parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.crates);
            allGst += parseFloat((productPrice * (parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.crates) * (parseFloat(data.gst)/100)).toFixed(2));
            allSubTotal += productPrice * (parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.crates);
            allQty += (parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.crates)|| 0;
            newDiscountValue += discount;
        });
    
        setNewTotal(allSubTotal);
        setNewGst(allGst);
        setScheme(getData?.schemeValue);
        setNewDiscount(newDiscountValue + scheme);
    };

    useEffect(() => {
        getNewTotal();
    },[newDiscountData]);


    const formatViewDate = (date) => {
    const newDate = new Date(date);
    if (isNaN(newDate)) {
      //console.error("Invalid date format");
      return;
    }

    const formattedDate = `${String(newDate.getDate()).padStart(
      2,
      "0"
    )}-${String(newDate.getMonth() + 1).padStart(
      2,
      "0"
    )}-${newDate.getFullYear()}`;
    return formattedDate;
  };

    // console.log(userType);
    

    const pendingLedger = parseFloat( parseFloat(getData?.dealerData?.invoiceTotal) - parseFloat(getData?.dealerData?.discountTotal) - parseFloat(getData?.dealerData?.paymentTotal) || 0 ).toFixed(2);


    const requestLedgerPermission = async () => {

        const sendData = {
            type: 'request',
            orderId: getData?.orderId,
            userName: userName,
            ledger: pendingLedger,
            dealer: getData?.dealerData?.dealer,
            amount: parseFloat((orderTotal + newGst) - parseFloat(newDiscount))
        };

        try{
            const response = await axios.post('https://api.trucoo.in/orders/ledger-permission/', sendData, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});

            // console.log(response.data);

            if(response.data.status === 'success'){
               alert('Request sent to the admin!');
            }else{
                alert('Unable to sent the request please try again!');
            }

        }catch (error) {
			console.error("Error:", error.response || error.message);
            alert('Unable to sent the request please try again!');
		}

    };

    const acceptLedgerPermission = async () => {

        const sendData = {
            type: 'approve',
            orderId: getData?.orderId,
        };

        try{
            const response = await axios.post('https://api.trucoo.in/orders/ledger-permission/', sendData, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});

            // console.log(response.data);

            if(response.data.status === 'success'){
                getdata();
                getTotal();
            }else{
                alert('Unable to sent the request please try again!');
            }

        }catch (error) {
			console.error("Error:", error.response || error.message);
            alert('Unable to sent the request please try again!');
		}

    };


    return (
    <>
        {loader && <Loader /> }
        <Header />
        <Sidebar />

        <div className="content-wrapper">
            <div className="container-full">
                <section class="content">
                    <div class="box">
                       
                        <div class="box-body">
                            <div class="row" >
                                <div class="col-lg-3 mb-4">
                                    <p class="text-bold">Date : {formatViewDate(getData?.orderDate)}</p>
                                    <p class="text-bold">Party : {getData?.dealerData?.dealer}</p>
                                </div>

                                <div class="col-lg-3 mb-4">
                                    <h6 class="">Discount Amount : {parseFloat(newDiscount).toFixed(2)}</h6> 
                                    <h6 class="mt-4">Discount Crates : {parseFloat(disCratesTotal).toFixed(2)}</h6> 
                                    <h6 class="mt-4">Scheme : {parseFloat(scheme).toFixed(2)} <small>( {getData?.dealerData?.values}/{getData?.dealerData?.fraction})</small></h6> 
                                </div>

                                <div class="col-lg-3 mb-4">
                                    {getData?.remarks?.length > 0 && 
                                        <div class="box-body" style={{padding: '20px', border: '1px solid #000', borderRadius: '10px'}}>
                                            <p style={{marginLeft: '-10px', marginTop: '-10px'}}>Notes</p>
                                            <p class="text-danger">{getData?.remarks}</p>
                                        </div>
                                    }
                                </div>

                                <div class="col-lg-3 mb-4" align="right">
                                    <div >
                                        <a className='btn btn-info mb-2' href="/new-invoices"><i class="fa fa-arrow-left"></i> Back to Invoices</a> <br /> 
                                        
                                        {getData?.orderData?.length > 0 ? 
                                            getData?.invoice === 'no' ?
                                                parseFloat(getData?.dealerData?.ledgerLimit) < parseFloat(pendingLedger) ?
                                                    getData?.ledgerPermit === 'no' ?
                                                        userType === 'admin1' || userType === 'admin2' || userType === 'account' ?
                                                            <div style={{border: '2px solid red', padding: '15px 10px', borderRadius: '10px'}}>
                                                                <p className='text-danger fs-12 text-bold'>Ledger limit exceeded for this party. To continue creating the invoice, grant permission.</p>
                                                                <button className='btn btn-success' onClick={acceptLedgerPermission}>Accept Permission</button>
                                                            </div>
                                                        :
                                                            <div style={{border: '2px solid red', padding: '15px 10px', borderRadius: '10px'}}>
                                                                <p className='text-danger fs-12 text-bold'>Ledger Limit Exceeded for this Party. To continue creating Invoice ask Permission from the Admins</p>
                                                                <button className='btn btn-danger' onClick={requestLedgerPermission}>Request Permission</button>
                                                            </div>
                                                    : <button className='btn btn-success' onClick={saveData}>Create Invoice</button>
                                                : <button className='btn btn-success' onClick={saveData}>Create Invoice</button>
                                            : <button className='btn btn-success' onClick={()=>{downloadPDF()}}>Download Pro-Forma</button>
                                        : <p class="text-danger">Please Add items to Create & Download Invoice</p>
                                        } <br /> 
                                         <button className='btn btn-warning mt-2' onClick={()=>setDiscSec(!discSec)}> {!discSec ? <><i class="fa fa-inr"></i>  Apply Discount </> : <><i class="fa fa-file"></i>  Invoice Details </>}</button>
                                    </div>
                                </div>
                                <hr  class="mb-4"/>
                                {discSec ?

                                <div class="col-lg-12">
                                    <div class="mb-4">
                                        <h5 class="box-title mt-4">Apply Discount</h5>
                                    </div>
                                    <div class="table-responsive">
                                        <table className="table-sm table-bordered" width="100%">
                                            <thead>
                                                <tr className="fs-10 fw-600 text-dark text-center">
                                                    <th width="3%">S.No</th>
                                                    <th>PARTICULARS</th>
                                                    <th width="7%">PACKET RATE</th>
                                                    <th width="5%">CRATES</th>
                                                    <th width="5%">QTY</th>
                                                    <th width="6%">LTR/KG</th>
                                                    <th width="30%">DISCOUNT</th>
                                                    <th width="7%">AMOUNT</th>
                                                    <th width="5%">DISCOUNT</th>
                                                    <th width="8%">TOTAL</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {getData?.orderData?.map((data, index) => {

                                                    const discount = getNewDiscounts(data.item);
                                                    const disCrates = getDiscountCrates(data.item);
                                                    const qty = parseFloat(parseFloat(data.qty)).toFixed(2);
                                                    const price = parseFloat(data.price);
                                                    const gst = parseFloat(data.gst);
                                                    const productGst = parseFloat(price - ( price / (1+ gst/100) ));
                                                    const productPrice = parseFloat(price - productGst);
                                                    const weight = ((parseFloat(data.qty) * parseFloat(data.crates)) *(parseFloat(data.weight) / 1000));
                                                    const count = (parseFloat(data.crates) * parseFloat(data.qty) || 0);
                                                    const rate = parseFloat(productPrice.toFixed(2)* (parseFloat(data.qty)* parseFloat(data.crates))).toFixed(2);
                                                    const gstRate = rate * (parseFloat(data.gst)/100);

                                                    const Total = parseFloat(parseFloat(rate));
                                                    const grandTotal = parseFloat(parseFloat(rate) + parseFloat(gstRate));

                                                    cratesTotal += Number( parseFloat(qty));
                                                    qtyTotal += parseFloat(qty) * parseFloat(data.crates);
                                                    weightTotal += weight;
                                                    orderTotal += Total;
                                                    disCratesTotal += disCrates;
                                                    gstTotal += Number(gstRate);

                                                    return(
                                                    <tr key={index} className="fw-400 text-gray-600  fs-12">
                                                        <td class="text-center">{index + 1}</td> 
                                                        <td class="text-left">{data.itemName}</td>
                                                        <td class="text-end">{productPrice.toFixed(2)}</td>
                                                        <td class="text-end">{Number( parseFloat(qty) + parseFloat(disCrates)).toFixed(2)}</td>
                                                        <td class="text-end">{count.toFixed(2)}</td>
                                                        <td class="text-end">{weight.toFixed(2)} {data.unit}</td>
                                                        <td>
                                                            <div class="input-group">
                                                                <select className="form-select" name="type" value={newDiscountData.find(entry => entry.item === data.item)?.type || ''} onChange={(e)=> handleDiscountTypeChange(e.target.value, data.item)}>
                                                                    <option value="" hidden>Select Options</option>
                                                                    <option value="liters">Littres</option>
                                                                    <option value="grade">Crates</option>
                                                                    <option value="packet">Packets</option>
                                                                </select>
                                                                <select className="form-select" name="discount" value={newDiscountData.find(entry => entry.item === data.item)?.discount || ''} onChange={(e)=> handleDiscountDiscountChange(e.target.value, data.item)}>
                                                                    <option value="" hidden>Select Options</option>
                                                                    <option value="amount">Amount</option>
                                                                    <option value="packet">Packet</option>
                                                                </select>
                                                                <input type="parseFloat" class="form-control" style={{textAlign: 'center'}} name="value" value={newDiscountData.find(entry => entry.item === data.item)?.value || ''} onChange={(e)=> handleDiscountValueChange(e.target.value, data.item)} />
                                                            </div>
                                                        </td>
                                                        <td class="text-end">{parseFloat(Total).toFixed(2)}</td>
                                                        <td class="text-end">{parseFloat(discount).toFixed(2)}</td>
                                                        <td class="text-end">{(parseFloat(grandTotal) - parseFloat(discount)).toFixed(2)}</td>
                                                    </tr>
                                                )})}
                                                    <tr>
                                                        <th colspan="3">Total</th>
                                                        <th class="text-end">{parseFloat(cratesTotal).toFixed(2)}</th>
                                                        <th class="text-end">{parseFloat(qtyTotal).toFixed(2)}</th>
                                                        <th class="text-end">{parseFloat(weightTotal).toFixed(2)}</th>
                                                        <th></th>
                                                        <th class="text-end">{parseFloat(orderTotal + newGst).toFixed(2)}</th>
                                                        <th class="text-end">{parseFloat(newDiscount).toFixed(2)}</th>
                                                        <th class="text-end">{(parseFloat(orderTotal + newGst) - parseFloat(newDiscount)).toFixed(2)}</th>
                                                    </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>     
                                : 
                                <div class="col-lg-12">
                                    <div class="mb-4">
                                        <h5 class="box-title mt-4">Invoice Details</h5>
                                    </div>
                                    
                                        <div class="table-responsive">
                                            <table className="table-sm table-bordered no-wrap" width="100%">
                                                <thead>
                                                    <tr className="fs-10 fw-600 text-dark text-center">
                                                        <th width="3%" rowSpan={2}>S.No</th>
                                                        <th rowSpan={2}>PARTICULARS</th>
                                                        <th width="7%" rowSpan={2}>PACKET RATE</th>
                                                        <th width="5%" rowSpan={2}>CRATES</th>
                                                        <th width="5%" rowSpan={2}>QTY</th>
                                                        <th width="6%" rowSpan={2}>LTR/KG</th>
                                                        <th width="7%" rowSpan={2}>AMOUNT</th>
                                                        {getData?.dealerData?.gstType === 'SGST' ?
                                                        <>
                                                            <th width="10%" colSpan={2}>SGST</th>
                                                            <th width="10%" colSpan={2}>CGST</th>
                                                        </>
                                                            :
                                                            <th width="10%" colSpan={2}>IGST</th>}
                                                        <th width="5%" rowSpan={2}>DISC AMT</th>
                                                        <th width="5%" rowSpan={2}>DISC CRT</th>
                                                        <th width="8%" rowSpan={2}>TOTAL</th>
                                                    </tr>
                                                    <tr className="fs-10 fw-600 text-dark text-center">
                                                    
                                                    {getData?.dealerData?.gstType === 'SGST' ?
                                                        <> 
                                                            <th>RATE</th>
                                                            <th>VALUE</th>
                                                            <th>RATE</th>
                                                            <th>VALUE</th>
                                                        </>
                                                        :
                                                        <>
                                                            <th>RATE</th>
                                                            <th>VALUE</th>
                                                        </>
                                                        }
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {getData?.orderData?.map((data, index) => {

                                                        const discount = getNewDiscounts(data.item);
                                                        const disCrates = getDiscountCrates(data.item);
                                                        const qty = parseFloat(parseFloat(data.qty)).toFixed(2);
                                                        const price = parseFloat(data.price);
                                                        const gst = parseFloat(data.gst);
                                                        const productGst = parseFloat(price - ( price / (1+ gst/100) ));
                                                        const productPrice = parseFloat(price - productGst);
                                                        const weight = ((parseFloat(data.qty) * parseFloat(data.crates)) *(parseFloat(data.weight) / 1000));
                                                        const count = (parseFloat(data.crates) * parseFloat(data.qty) || 0);
                                                        const rate = parseFloat(productPrice.toFixed(2)* (parseFloat(data.qty)* parseFloat(data.crates))).toFixed(2);
                                                        const gstRate = (rate * (parseFloat(data.gst)/100)).toFixed(2);
                                                        const sGstRate = parseFloat(gstRate/2).toFixed(2);
                                                        const cGstRate = parseFloat(gstRate/2).toFixed(2);

                                                        const Total = parseFloat(parseFloat(rate));
                                                        const grandTotal = parseFloat( parseFloat(rate) + parseFloat(cGstRate) + parseFloat(sGstRate) ).toFixed(2);

                                                        cratesTotal += Number( parseFloat(qty));
                                                        qtyTotal += parseFloat(qty) * parseFloat(data.crates);
                                                        weightTotal += weight;
                                                        orderTotal += Total;
                                                        disCratesTotal += disCrates;
                                                        gstTotal += Number(gstRate);
                                                        

                                                        return(
                                                        <tr key={index} className="fw-400 text-gray-600  fs-12">
                                                            <td class="text-center">{index + 1}</td> 
                                                            <td class="text-left">{data.itemName}</td>
                                                            <td class="text-end">{productPrice.toFixed(2)}</td>
                                                            <td class="text-end">{Number( parseFloat(qty)).toFixed(2)}</td>
                                                            <td class="text-end">{count.toFixed(2)}</td>
                                                            <td class="text-end">{weight.toFixed(2)} {data.unit}</td>
                                                            <td class="text-end">{parseFloat(Total).toFixed(2)}</td>
                                                            {getData?.dealerData?.gstType === 'SGST' ?
                                                                <>
                                                                    <td class="text-center">{Number(data.gst) > 0 ? '2.5%' : '0%'}</td>
                                                                    <td class="text-end">{parseFloat(sGstRate).toFixed(2)}</td>
                                                                    <td class="text-center">{Number(data.gst) > 0 ? '2.5%' : '0%'}</td>
                                                                    <td class="text-end">{parseFloat(cGstRate).toFixed(2)}</td>
                                                                </>
                                                                :
                                                                <>
                                                                    <td class="text-center">{Number(data.gst) > 0 ? '5%' : '0%'}</td>
                                                                    <td class="text-end">{parseFloat(gstRate).toFixed(2)}</td>
                                                                </>
                                                            }
                                                            <td class="text-end">{parseFloat(discount).toFixed(2)}</td>
                                                            <td class="text-end">{parseFloat(disCrates).toFixed(2)}</td>
                                                            <td class="text-end">{(parseFloat(grandTotal) - parseFloat(discount)).toFixed(2)}</td>
                                                        </tr>
                                                    )})}
                                                        <tr>
                                                            <th colspan="3">Total</th>
                                                            <th class="text-end">{parseFloat(cratesTotal).toFixed(2)}</th>
                                                            <th class="text-end">{parseFloat(qtyTotal).toFixed(2)}</th>
                                                            <th class="text-end">{parseFloat(weightTotal).toFixed(2)}</th>
                                                            <th class="text-end">{parseFloat(orderTotal).toFixed(2)}</th>
                                                        {getData?.dealerData?.gstType === 'SGST' ?
                                                                <>
                                                                    <th></th>
                                                                    <th class="text-end">{parseFloat(gstTotal/2).toFixed(2)}</th>
                                                                    <th></th>
                                                                    <th class="text-end">{parseFloat(gstTotal/2).toFixed(2)}</th>
                                                                </>
                                                                :
                                                                <>
                                                                    <th></th>
                                                                    <th class="text-end">{parseFloat(gstTotal).toFixed(2)}</th>
                                                                </>
                                                            }
                                                            <th class="text-end">{parseFloat(newDiscount + scheme).toFixed(2)}</th>
                                                            <th class="text-end">{parseFloat(disCratesTotal).toFixed(2)}</th>
                                                            <th class="text-end">{(parseFloat(orderTotal + gstTotal) - parseFloat(newDiscount + scheme)).toFixed(2)}</th>
                                                        </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    }
                                </div>
                       

                <div className="invoice hide" id="printableArea"  style={{ maxWidth: '100%', padding: '5mm', boxSizing: 'border-box', border: '1px solid #000', justifyContent: 'center' }}>
                        <div className="row align-items-center justify-content-md-center h-p100">
                            <div className="col-sm-2">
                                <img src={Logo} width="100%" />
                            </div>
                            <div className="col-sm-5 text-fade" align="left">
                                <h6 className="text-left text-dark" style={{fontWeight: '600'}}>{companyData?.companyName}</h6>
                                <address className="text-left">
                                    {companyData?.companyAddress1}, {companyData?.companyAddress2}
                                    <br></br>
                                    {companyData?.companyLocation}, {companyData?.companyCity},
                                    {companyData?.companyState} - {companyData?.companyZip} <br />
                                    {companyData?.companyGst}<br />
                                    {companyData?.companyPhone} &nbsp;&nbsp;&nbsp; {companyData?.companyEmail}
                                </address>
                            </div>
                            
                            <div className="col-sm-3 d-flex" align="left">
                               <p class="text-dark">
                                Date : {getData?.orderDate}<br />
                                Invoice No : PRO_FORMA <br />
                                Zone : {getData?.dealerData?.zoneData?.zone} <br />
                                Route : {getData?.dealerData?.routes} <br />
                                Place : {getData?.dealerData?.locations}
                               </p>
                            </div>

                            <div className="col-sm-2 d-flex justify-content-end mb-4">
                               {/* <img src={Qr} alt="QR Code" width="200px" style={{marginRight: '-20px'}} /> */}
                               { payable && payable > 0 && <QRCodeCanvas value={generateUpiLink()} size={150}  /> }
                            </div>


                            <div className="table-responsive">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th className="text-center" colSpan="2">PRO_FORMA Invoice</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td width="50%" className="text-dark">
                                                <address >
                                                    <p className="text-dark text-uppercase">Billing Address</p>
                                                    <h6 style={{fontWeight: '600', fontSize: '14px'}}>{getData?.dealerData?.dealer}</h6>
                                	                {getData?.dealerData?.address}<br />
                                                    {getData?.dealerData?.phone}<br />{getData?.dealerData?.email}<br />
                                                    GSTIN : {getData?.dealerData?.gst}<br />
                                                    State : {getData?.dealerData?.state} &nbsp;&nbsp;&nbsp;
                                                    Code : {getData?.dealerData?.stateCode}
                                                </address>
                                            </td>
                                            <td className="text-dark">
                                                <address >
                                                    <p className="text-dark text-uppercase">Shipping Address</p>
                                                    <h6 style={{fontWeight: '600', fontSize: '14px'}}>{getData?.shipping?.company}</h6>
                                	                {getData?.shipping?.address} <br />
                                                    <p>{getData?.shipping?.phone} &nbsp;&nbsp;&nbsp; {getData?.shipping?.email}</p>
                                                </address>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div className="table-responsive ">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr className="fs-10 fw-600 text-dark">
                                            <th rowspan="2" width="3%">S.No</th>
                                            <th rowspan="2">PARTICULARS</th>
                                            <th rowspan="2" width="8%">HSN/SAC</th>
                                            <th rowspan="2" width="4%">UNIT</th>
                                            <th rowspan="2" width="8%">CRATES</th>
                                            <th rowspan="2" width="8%">QTY</th>
                                            <th rowspan="2" width="8%">LTR/KG</th>
                                            <th rowspan="2" width="6%">RATE/QTY</th>
                                            <th rowspan="2" width="8%">AMOUNT</th>
                                            {getData?.dealerData?.gstType === 'SGST' ? 
                                                <>
                                                    <th colspan="2" width="8%">CGST</th>   
                                                    <th colspan="2" width="8%">SGST Rate (%)</th>
                                                </>
                                            :
                                                <th colspan="2" width="8%">IGST</th>  
                                            }
                                            <th rowspan="2" width="10%">Total Amount</th>
                                        </tr>
                                        <tr className="fs-10 fw-800 text-dark">
                                            {getData?.dealerData?.gstType === 'SGST' && 
                                            <>
                                                <th>Rate(%) </th>
                                                <th>Value </th>
                                            </>
                                            }
                                          <th>Rate(%) </th>
                                          <th>Value </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {getData?.orderData?.map((data, index) => {
                                          
                                            const price = parseFloat(data.price);
                                            const gst = parseFloat(data.gst);
                                            const productGst = parseFloat(price - ( price / (1+ gst/100) ));
                                            const productPrice = parseFloat(price - productGst);

                                            const disCrates = getDiscountCrates(data.id);
                                            //console.log(disCrates);

                                            const rate = parseFloat(productPrice.toFixed(2)* ((parseFloat(data.qty)+ parseFloat(disCrates))* parseFloat(data.crates))).toFixed(2);
                                            const gstRate = rate * (parseFloat(data.gst)/100);
                                            const gstRate2 = parseFloat(gstRate / 2).toFixed(2);
                                           

                                            return(
                                            <tr key={index} className="fw-400 text-gray-600  fs-12">
                                                <td>{index + 1}</td> 
                                                <td class="text-left">{data.itemName}</td>
                                                <td class="text-left">{data.itemHsn}</td>
                                                <td>{data.unit}</td>
                                                <td>{(parseFloat(data.qty)+ parseFloat(disCrates)).toFixed(2)}</td>
                                                <td>{((parseFloat(data.qty)+ parseFloat(disCrates)) * parseFloat(data.crates)).toFixed(2)}</td>
                                                <td>{(((parseFloat(data.qty)+ parseFloat(disCrates)) * parseFloat(data.crates) * parseFloat(data.weight)/1000)).toFixed(2)}</td>
                                                <td>{parseFloat(productPrice).toFixed(2)}</td>
                                                <td>{rate}</td>
                                                {getData?.dealerData?.gstType === 'SGST' ?
                                                    <>
                                                        <td>{parseFloat(data.gst/2).toFixed(1)}%</td>
                                                        <td>{(gstRate/2).toFixed(2)}</td>
                                                        <td>{parseFloat(data.gst/2).toFixed(1)}%</td>
                                                        <td>{(gstRate/2).toFixed(2)}</td>
                                                    </>
                                                :
                                                    <>
                                                        <td>{parseFloat(data.gst).toFixed(1)}%</td>
                                                        <td>{(parseFloat((productGst) * (parseFloat(data.qty)+ parseFloat(disCrates))* parseFloat(data.crates))).toFixed(2)}</td>
                                                    </>
                                                } 

                                                <td class="text-end">
                                                    {
                                                      parseFloat(
                                                        parseFloat(rate) + parseFloat(gstRate2) + parseFloat(gstRate2)
                                                      ).toFixed(2)

                                                    }
                                                </td>

                                                                                                
                                            </tr>);
                                           })}
                                       
                                        <tr>
                                            
                                            <th colspan="4">TOTAL</th>
                                            <th>{parseFloat(crates).toFixed(2)}</th>
                                            <th>{parseFloat(qty).toFixed(2)}</th>
                                            <th>{parseFloat(totalLtr).toFixed(2)}</th>
                                            <td></td>
                                            <th>{parseFloat(total).toFixed(2)}</th>
                                            <td></td>
                                            {getData?.dealerData?.gstType === 'SGST' ?
                                                <>
                                                    <th>{parseFloat(gst/2).toFixed(2)}</th>
                                                    <td></td>
                                                    <th>{parseFloat(gst/2).toFixed(2)}</th>
                                                </>
                                                :
                                                <th>{parseFloat(gst).toFixed(2)}</th>
                                            }
                                            
                                            <th class="text-end">{parseFloat( parseFloat(total) + parseFloat(gst2) + parseFloat(gst2) ).toFixed(2)}</th>

   
                                        </tr>
                                        <tr>
                                            <td  className="text-center" colSpan={getData?.dealerData?.gstType === 'SGST' ? 8 : 7}>
                                                Our Bank Details
                                            </td>
                                            <td className="text-left" colSpan={getData?.dealerData?.gstType === 'SGST' ? 7 : 6} rowspan="2">
                                                <small>We request you to make the payment through our UPI ID <br />QR919843022841-0082@unionbankofindia</small>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td  className="text-end" colSpan="2">
                                                <span>A/C Holder</span> <br />
                                                <span>BANK</span><br />
                                                <span>BRANCH</span>  <br />
                                                <span>A/C NO</span> <br />
                                                <span>IFSC CODE</span>
                                            </td>
                                            <td  className="text-left" colSpan={getData?.dealerData?.gstType === 'SGST' ? 7 : 6}>
                                                <span>TRUCOO DAIRY PRODUCTS PRIVATE LIMITED</span> <br />
                                                <span>UNION BANK OF INDIA</span><br />
                                                <span>COIMBATORE</span> <br />
                                                <span>008311010000082</span> <br />
                                                <span>UBIN0800830</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-left" colSpan={getData?.dealerData?.gstType === 'SGST' ? 9 : 7} >Electronic Referance Number:</td>
                                            <td className="text-left" colSpan="3">BILL AMOUNT</td>
                                            <td class="text-end" colSpan="2">{parseFloat( parseFloat(total) + parseFloat(gst2) + parseFloat(gst2) ).toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            <th className="text-left" colSpan={getData?.dealerData?.gstType === 'SGST' ? 9 : 7} rowspan="3">
                                                Payable Amount In words <br /> {totalAmountInWords.toUpperCase()} RUPEES ONLY
                                            </th>
                                            <td className="text-left" colSpan="3">DISCOUNT</td>
                                            <td class="text-end" colSpan="2">{parseFloat(newDiscount + scheme).toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            <td className="text-left" colSpan="3">ROUND AMOUNT</td>
                                            <td class="text-end" colSpan="2">{parseFloat(Math.round(payable)).toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                           
                                            <th className="text-left" colSpan="3">GRAND TOTAL</th>
                                            <th class="text-end" colSpan="2">{parseFloat(Math.round(payable)).toFixed(2)}</th>
                                        </tr>
                                       
                                        <tr>
                                            <td className="text-left" colSpan="5">E&OE</td>
                                            <td className="text-center" colSpan="9">{companyData?.companyName}</td>
                                        </tr>
                                        <tr>
                                          <td className="text-left" colSpan="3" style={{paddingBottom: '90px'}}>Received By</td>
                                          <td className="text-left" colSpan="3" style={{paddingBottom: '90px'}}>Prepared By <br /><br />{userName}</td>
                                          <td className="text-left" colSpan="4" style={{paddingBottom: '90px'}}>Charge</td>
                                          <td className="text-left" colSpan="4" style={{paddingBottom: '90px'}}>Authorized Signature</td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>                                           

                        </div>
                    </div>

                    </div>
                    </div>
                </section>
            </div>
        </div>
        <Footer />
    </>
    );
}

export default InvoicePage;